module.exports = __webpack_public_path__ + "img/it.71a8bd4b.png";